module.exports = __webpack_public_path__ + "05b985988ffe77938d1fd546d8a22f2b.mp3";